export default __webpack_public_path__ + "static/media/akar-icons_youtube-fill.e0efb718.svg";